import { TokenProps } from '@procore/core-react/dist/_typedoc/Token/Token.types.json';
import { Props } from '@procore/core-react/dist/_typedoc/_utils/types.json';
import * as React from 'react';
export default {
  TokenProps,
  Props,
  React
};